export default [
	{
		id: 0.1,
		name: 'intermittent-fasting',
		property: 'intermittentFasting',
		isData: false
	},
	{
		id: 0.2,
		name: 'intermittent-fasting-about'
	},
	{
		id: 1,
		name: 'Number of meals',
		router: 'number_of_meals',
		property: 'meals',
		isData: true,
		visible: true,
		options: [
			{
				id: 1,
				label: '1 (intermittent fasting)',
				value: '1'
			},
			{
				id: 2,
				label: '2 (intermittent fasting)',
				value: '2'
			},
			{
				id: 3,
				label: '3',
				value: '3'
			},
			{
				id: 4,
				label: '4+',
				value: '4'
			}
		]
	},
	{
		id: 2,
		name: 'Do you eat carbs?',
		router: 'do_you_eat_carbs',
		visible: true,
		isData: true,
		property: 'carbs',
		options: [
			{
				label: 'Very often',
				selected: false,
				value: 'often'
			},
			{
				label: 'Sometimes',
				selected: false,
				value: 'sometimes'
			},
			{
				label: 'Rarely',
				selected: false,
				value: 'rarely'
			},
			{
				label: 'Not at all',
				selected: false,
				value: 'never'
			}
		]
	},
	{
		id: 3,
		name: 'diet',
		router: 'any_specific_diet',
		isData: true,
		property: 'diet',
		visible: true,
		options: [
			{
				label: 'No',
				selected: false,
				value: 'regular'
			},
			{
				label: 'Keto',
				selected: false,
				value: 'keto'
			},
			{
				label: 'Lactose-free',
				selected: false,
				value: 'lactose_free'
			},
			{
				label: 'Gluten-free',
				selected: false,
				value: 'gluten_free'
			},
			{
				label: 'Other',
				selected: false,
				value: 'other'
			}
		]
	},
	{
		id: 4,
		name: 'Regular diet vs Simple',
		router: 'regular_diet_vs_simple',
		visible: true
	},
	{
		id: 5,
		name: 'How do you sleep?',
		router: 'how_do_you_sleep',
		property: 'sleep',
		isData: true,
		visible: true,
		options: [
			{
				label: 'It takes a long time to fall asleep',
				selected: false,
				value: 'long_time'
			},
			{
				label: 'I go to sleep after 11 pm',
				selected: false,
				value: 'after_11pm'
			},
			{
				label: 'I sleep less than 7 hours',
				selected: false,
				exception: ['10_hours', '8_hours'],
				value: '7_hours'
			},
			{
				label: 'I sleep more than 10 hours',
				selected: false,
				value: '10_hours',
				exception: ['7_hours', '8_hours']
			},
			{
				label: 'I never feel rested',
				selected: false,
				value: 'rested'
			},
			{
				label: 'I get the recommended 8 hours',
				selected: false,
				value: '8_hours',
				exception: ['7_hours', '10_hours']
			}
		]
	},
	{
		id: 6,
		name: 'How much water you drink?',
		router: 'how_much_water_you_drink',
		isData: true,
		property: 'waterDrink',
		visible: true
	},
	{
		id: 7,
		name: 'What’s your job like?',
		router: 'whats_your_job_like',
		property: 'work',
		isData: true,
		visible: true,
		options: [
			{
				id: 1,
				label: 'Not active',
				value: 'sedentary'
			},
			{
				id: 2,
				label: 'Somewhat active',
				value: 'mid_active'
			},
			{
				id: 3,
				label: 'Very active',
				value: 'phisically_demanding'
			}
		]
	},
	{
		id: 8,
		name: 'How often do you work out?',
		router: 'how_often_do_you_work_out',
		property: 'sport',
		isData: true,
		visible: true,
		options: [
			{
				id: 1,
				label: 'Never',
				value: 'not_at_all'
			},
			{
				id: 2,
				label: 'Rarely',
				value: 'rare'
			},
			{
				id: 3,
				label: 'Occasionally',
				value: 'changing_load'
			},
			{
				id: 4,
				label: 'Regularly',
				value: 'regular'
			}
		]
	},

	{
		id: 9,
		name: 'What’s your primary gender?',
		router: 'gender',
		property: 'sex',
		isData: false,
		visible: true,
		options: [
			{
				id: 1,
				label: 'Female',
				value: 'female'
			},
			{
				id: 2,
				label: 'Male',
				value: 'male'
			}
		]
	},
	{
		id: 10,
		name: 'Sticking to a plan',
		router: 'sticking_to_plan',
		visible: true
	},
	{
		id: 11,
		name: 'What is your age?',
		router: 'age',
		property: 'age',
		isData: true,
		visible: true
	},
	{
		id: 12,
		name: 'What is your body type?',
		router: 'your_body_type',
		isData: true,
		property: 'bodyType',
		visible: true,
		options: [
			{
				id: 1,
				label: 'Pear Shaped',
				note: 'Slim through the shoulders and torso with muscular or naturally thicker bum & thighs.',
				img: 'icon-pear-shaped',
				value: 'pear_shaped'
			},
			{
				id: 2,
				label: 'Long and Lean',
				note: 'I had difficulty gaining weight in my younger years.',
				img: 'icon-long-lean',
				value: 'long_and_lean'
			},
			{
				id: 3,
				label: 'Square Shape',
				note: 'A sturdy, stocky frame that is naturally strong.',
				img: 'icon-square-shape',
				value: 'square_shape'
			},
			{
				id: 4,
				label: 'Inverted Triangle Shaped',
				note: 'Relatively slim through my waist and hips but bulkier up top through the arms and shoulders.',
				img: 'icon-inverted-triangle',
				value: 'inverted_triangle_shaped'
			}
		]
	},
	{
		id: 13,
		name: 'Preliminary processing',
		router: 'processing',
		visible: true
	},
	{
		id: 14,
		name: 'Any medical conditions?',
		router: 'any_medical_conditions',
		property: 'diseases',
		isData: true,
		visible: true,
		options: [
			{
				label: 'Anorexia',
				selected: false,
				value: 'anorexia'
			},
			{
				label: 'Bulimia',
				selected: false,
				value: 'bulimia'
			},
			{
				label: 'Diabetes',
				selected: false,
				value: 'type_1_diabetes'
			},
			{
				label: 'High blood pressure',
				selected: false,
				value: 'high_blood_pressure'
			},
			{
				label: 'High cholesterol',
				selected: false,
				value: 'high_cholesterol'
			},
			{
				label: 'Stress, anxiety, or depression',
				selected: false,
				value: 'stress_anxiety_depression'
			},
			{
				label: 'Other',
				selected: false,
				value: 'other'
			}
		]
	},
	{
		id: 15,
		name: 'Do you take any medication?',
		router: 'do_you_take_any_medication',
		property: 'drugs',
		isData: true,
		visible: true,
		options: [
			{
				label: 'Vitamins',
				selected: false,
				value: 'vitamins'
			},
			{
				label: 'Hormones',
				selected: false,
				value: 'hormones'
			},
			{
				label: 'Antibiotics',
				selected: false,
				value: 'antibiotics'
			},
			{
				label: 'Other',
				selected: false,
				value: 'other'
			},
			{
				label: 'I am not taking anything',
				selected: false,
				value: 'not_taking'
			}
		]
	},
	{
		id: 17,
		name: 'current',
		isData: false,
		router: 'your_current_state',
		property: ['birthDate', 'height', 'weight']
	},

	{
		id: 18,
		name: 'Area',
		router: 'area',
		property: 'area',
		isData: true,
		visible: true,
		options: [
			{
				label: 'Arms',
				selected: false,
				value: 'arms'
			},
			{
				label: 'Shoulders',
				selected: false,
				value: 'shoulders'
			},
			{
				label: 'Chest',
				selected: false,
				value: 'chest'
			},
			{
				label: 'Belly',
				selected: false,
				value: 'belly'
			},
			{
				label: 'Butt',
				selected: false,
				value: 'butt'
			},
			{
				label: 'Leggs',
				selected: false,
				value: 'leggs'
			}
		]
	},

	{
		id: 19,
		name: 'Goal',
		router: 'goal',
		property: 'goal',
		isData: true,
		visible: true,
		options: []
	},
	{
		id: 20,
		name: 'additional-question-1',
		property: 'rq_1',
		isData: true
	},
	{
		id: 21,
		name: 'additional-question-2',
		property: 'rq_2',
		isData: true
	},

	{
		id: 22,
		name: 'additional-question-3',
		property: 'rq_3',
		isData: true
	},

	{
		id: 23,
		name: 'additional-question-4',
		property: 'rq_4',
		isData: true
	},

	{
		id: 24,
		name: 'motivation-events',
		property: 'motivation_event',
		isData: true
	},
	{
		id: 25,
		name: 'motivation-events-date',
		property: 'specialEvent',
		isData: true
	},

	{
		id: 26,
		name: 'weight-loss-speed'
	},
	{
		id: 27,
		name: 'following-statement-1',
		property: 'following_statement_1',
		isData: true
	},
	{
		id: 28,
		name: 'following-statement-2',
		property: 'following_statement_2',
		isData: true
	},
	{
		id: 29,
		name: 'following-statement-3',
		property: 'following_statement_3',
		isData: true
	},
	{
		id: 30,
		name: 'following-statement-4',
		property: 'following_statement_4',
		isData: true
	},
	{
		id: 31,
		name: 'following-statement-5',
		property: 'following_statement_5',
		isData: true
	},
	{
		id: 32,
		name: 'following-statement-6',
		property: 'following_statement_6',
		isData: true
	},
	{
		id: 33,
		name: 'storytelling'
	},
	{
		id: 34,
		name: 'stats'
	},
	{
		id: 35,
		name: 'trust'
	},
	{
		id: 36,
		name: 'result'
	},
	{
		id: 37,
		name: 'health_notice'
	},
	{
		id: 38,
		name: 'result_complete'
	}
]
